import { useMemo, useState } from "react";
import { X } from "lucide-react";
import { createBarcode } from "@/utils/barcode";

function BarcodeSvg({ barcode, height = 54 }) {
  if (!barcode || barcode.error) return null;
  return (
    <svg viewBox={`0 0 ${barcode.width} ${height}`} preserveAspectRatio="none" role="img" aria-label={`${barcode.format} barkodu ${barcode.value}`} className="block h-full w-full bg-white" shapeRendering="crispEdges">
      <rect width={barcode.width} height={height} fill="white" />
      {barcode.bars.map((bar) => <rect key={`${bar.x}-${bar.width}`} x={bar.x} y="0" width={bar.width} height={height} fill="#020617" />)}
    </svg>
  );
}

export default function StockBarcode({ value }) {
  const [open, setOpen] = useState(false);
  const barcode = useMemo(() => createBarcode(value), [value]);
  if (!barcode) return <div className="mt-4 w-[76px] text-center text-[9px] font-medium leading-tight text-slate-400">Barkod tanımlanmamış</div>;
  if (barcode.error) return <div className="mt-4 w-[76px] text-center text-[9px] font-medium leading-tight text-amber-600">Barkod görüntülenemiyor</div>;
  return (
    <>
      <button type="button" onClick={() => setOpen(true)} className="mt-4 flex h-[48px] w-[76px] flex-col items-center justify-center gap-0.5 rounded-md border border-slate-200 bg-white p-1 shadow-sm hover:border-[#0D1B3E]/40" title="Barkodu büyüt">
        <span className="mx-auto block h-6 w-[58px]"><BarcodeSvg barcode={barcode} height={32} /></span>
        <span className="block w-full truncate text-center font-mono text-[6px] leading-tight text-slate-500">{barcode.value}</span>
      </button>
      {open && (
        <div className="fixed inset-0 z-[80] flex items-center justify-center bg-black/55 p-5" onClick={() => setOpen(false)}>
          <div className="w-full max-w-md rounded-2xl bg-white p-5 shadow-2xl" onClick={(event) => event.stopPropagation()}>
            <div className="mb-4 flex items-center justify-between gap-3"><div><h3 className="font-bold text-[#0D1B3E]">Ürün Barkodu</h3><p className="text-xs text-slate-400">{barcode.format}</p></div><button type="button" onClick={() => setOpen(false)} aria-label="Kapat" className="rounded-full p-2 text-slate-400 hover:bg-slate-100 hover:text-slate-700"><X size={18}/></button></div>
            <div className="rounded-xl border border-slate-200 bg-white px-4 py-5">
              <div className="mx-auto h-28 w-full max-w-[360px]"><BarcodeSvg barcode={barcode} height={72} /></div>
              <div className="mt-3 select-text text-center font-mono text-base font-semibold tracking-[0.18em] text-slate-900">{barcode.value}</div>
            </div>
            <p className="mt-3 text-center text-xs text-slate-400">Okuyucuyu barkodun tamamını görecek şekilde ekrana doğrultun.</p>
          </div>
        </div>
      )}
    </>
  );
}
